import axios from "axios";
import constants from "../shared/constants";

const api = axios.create({
  baseURL: constants.apiURL,
});

export default api;
